import React from 'react';
import { Typography, Box, Avatar } from '@mui/material';
import { Circle as CircleIcon, NotificationsNone as BellIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { formatDistanceToNow } from 'date-fns';

// "position_update" -> "Position update"
const readable = (ntype = '') => (ntype.charAt(0).toUpperCase() + ntype.slice(1)).replace(/_/g, ' ');

/** The last resort for a notification without a card of its own: its message (or its kind), so a counted
 *  notification is never an empty line in the list. */
export default function GenericNotificationCard({ notification, onMarkRead }) {
  const navigate = useNavigate();
  const p = notification.payload || {};
  const text = p.message || p.title || p.text || readable(notification.ntype) || 'Notification';

  const open = () => {
    if (!notification.is_read && onMarkRead) onMarkRead();
    if (p.url) navigate(p.url);
  };

  return (
    <Box onClick={open} sx={{
      display: 'flex', alignItems: 'flex-start', gap: 1.5, py: 1.25, px: 2,
      borderBottom: '1px solid', borderColor: 'divider',
      backgroundColor: notification.is_read ? 'transparent' : 'action.hover',
      cursor: 'pointer', '&:hover': { backgroundColor: 'action.selected' },
    }}>
      <Avatar sx={{ width: 34, height: 34, mt: 0.25, bgcolor: 'primary.avatar', color: 'white' }}>
        <BellIcon sx={{ fontSize: 18 }} />
      </Avatar>
      <Typography variant="body2" sx={{ flex: 1, minWidth: 0 }}>{text}</Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
        <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
          {formatDistanceToNow(new Date(notification.created), { addSuffix: true })}
        </Typography>
        {!notification.is_read && <CircleIcon sx={{ fontSize: 8, color: 'primary.main' }} />}
      </Box>
    </Box>
  );
}
